module.exports = __webpack_public_path__ + "img/report.274317f3.svg";